import { createSelector } from 'reselect'
import getMerchandiseItems from '../items/getMerchandiseItems'
import { isNonNullable } from 'lib/array/arrayUtils'
import getMerchandiseShippingItems from '../items/getMerchandiseShippingItems'

const getMerchandiseItemViews = createSelector(
  (state: App.State) => getMerchandiseItems(state),
  (state: App.State) => getMerchandiseShippingItems(state),
  (state: App.State) => state.merchandise.merchandise,
  (state: App.State) => state.merchandise.merchandiseShipping,
  (items, shippingItems, merchandise, shipping): App.WithDataStatus<Array<App.Checkout.MerchandiseItemView>> => {
    const views = items.map((item): App.Checkout.MerchandiseItemView | undefined => {
      const offer = merchandise[item.advertId]
      const variant = offer?.variants.find((variant) => variant.id === item.variantId)

      if (!offer || !variant) {
        return undefined
      }

      return {
        title: offer.name,
        item,
        offer,
        variant,
        shipping: shipping[item.variantId],
        shippingItem: shippingItems.find((shippingItem) => shippingItem.shippingId === item.shippingId)!,
        loyalty: {
          productType: variant.loyalty.productType,
        },
        totals: {
          price: variant.price ?? 0,
          memberPrice: 0,
          value: variant.price ?? 0,
          memberValue: 0,
          surcharge: 0,
          extraGuestSurcharge: 0,
          taxesAndFees: 0
        },
      }
    }).filter(isNonNullable)

    return {
      hasRequiredData: items.length === views.length,
      data: views,
    }
  },
)

export default getMerchandiseItemViews
